import config from 'config'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import ChiliVariables from 'shared/components/Tools/services/ChiliVariables'
import CMYK from 'shared/entities/CMYK'
import useDebouncedCallback from 'shared/hooks/useDebouncedCallback'
import { ColorCMYK } from 'shared/types/global'
import Flex from 'shared/ui/Flex'
import Input from 'shared/ui/Input'

import ColorsSet from '../ColorsSet'

const variablesApi = ChiliVariables.getInstance()

const CoverStratEditingPanelSpineText = () => {
  const { formatMessage } = useIntl()

  const [value, setValue] = useState('')
  const [spineColor, setSpineColor] = useState<CMYK | null>(null)

  const fetchSpineText = async () => {
    const spineText = await variablesApi.getVariable(
      config.themes.variablesKeys.cover.spine.text
    )
    setValue(spineText.value)
  }

  const fetchSpineColor = async () => {
    const colorVar = await variablesApi.getVariable(
      config.themes.variablesKeys.cover.spine.textColor
    )
    const parsed = variablesApi.parseColorVariable(
      colorVar?.value ?? ''
    )
    if (parsed) {
      setSpineColor(new CMYK(parsed))
    }
  }

  const debouncedSetText = useDebouncedCallback(
    (val: string) =>
      variablesApi.setVariableValue(
        config.themes.variablesKeys.cover.spine.text,
        val
      ),
    100
  )

  const debouncedSetColor = useDebouncedCallback(
    (color: ColorCMYK) =>
      variablesApi.setVariableValue(
        config.themes.variablesKeys.cover.spine.textColor,
        variablesApi.convertColorToVariableValue(color)
      ),
    100
  )

  const handleTextChange = (newValue: string) => {
    setValue(newValue)
    debouncedSetText(newValue)
  }

  const handleColorChange = (color: ColorCMYK) => {
    setSpineColor(new CMYK(color))
    debouncedSetColor(color)
  }

  useEffect(() => {
    if (!variablesApi.isInitialized) {
      return
    }

    fetchSpineText()
    fetchSpineColor()
  }, [variablesApi.isInitialized])

  return (
    <div>
      <Input
        padding={[13, 16]}
        label={formatMessage({
          id: 'Panel.coverStartEdititing.spineText.label'
        })}
        size="small"
        value={value}
        onChange={handleTextChange}
        fontSize={14}
      />

      <Flex marginTop={16}>
        <ColorsSet
          labelId="Panel.startEditing.spineTextColor.label"
          currentColor={
            spineColor ?? new CMYK({ c: 0, m: 0, y: 0, k: 0 })
          }
          onCurrentClick={handleColorChange}
          onOtherClick={handleColorChange}
        />
      </Flex>
    </div>
  )
}

export default CoverStratEditingPanelSpineText
